import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import DateUtil from '../util/Util';

class ProjectController {

  static Staff = 'responsible_person';

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let project ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      //TODO: special 
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        project[keys[i]] = '';
        if(val === 'today') project[keys[i]] = DateUtil.dateToServerDateTime(new Date());
      } else if(fieldType === Const.Address) {
        project[keys[i]] = [];
      } else if(keys[i] === ProjectController.Staff) {
        project[keys[i]] = '~' + user + '~';
      } else if(fieldType.includes(Const.MultiSelect)) {
        project[keys[i]] = '';
        if(val) {
          project[keys[i]] = '~' + val.replace(',', '~') + '~';
        }
      } else {
        project[keys[i]] = val;
      }
    }
    project.status = Const.Active;
    return project;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i] !== 'id' && keys[i] !== 'status'
        && keys[i] !== 'acres99_code' && keys[i] !== 'acres99_project_name' && keys[i] !== 'amenities'
        && keys[i] !== 'area' && keys[i] !== 'phone' && keys[i] !== 'email' && keys[i] !== 'developer_name'
        && keys[i] !== 'magicbrics_code' && keys[i] !== 'anniversary' && keys[i] !== 'industry'
        && keys[i] !== 'responsible_person' && keys[i] !== 'posession_date'
        && keys[i] !== 'possession' && keys[i] !== 'project_id' && keys[i] !== 'project_name'
        && keys[i] !== 'project_type' && keys[i] !== 'rera_num' && keys[i] !== 'total_land_parcel'
        && keys[i] !== 'total_towers' && keys[i] !== 'address' && keys[i] !== 'description'
        && keys[i] !== 'created_by' && keys[i] !== 'updated_by'
        && keys[i] !== 'created_date' && keys[i] !== 'updated_date'
        && fields[keys[i]].status !== Const.Trash) {
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default ProjectController;